import type { ObjectGraph } from '@jet/environment/dependencies';
import { ClassicalAPIURL } from './ClassicalAPIURL';
import type { ClassicalAPIResponse } from './types';
import { requestClassicalAPIResource } from '../utilities/requestClassicalAPIResource';

export async function requestQueryPlaybackData(
    query: string,
    objectGraph: ObjectGraph,
): Promise<ClassicalAPIResponse> {
    const url = new ClassicalAPIURL(query, objectGraph);

    return requestClassicalAPIResource({ url: url.string }, objectGraph);
}
